import { ComputerIcon } from '@/features/lobby/icons'
import type { PlayerColor } from '@/shared/board/types'

/**
 * Кружок с первой буквой ника.
 *
 * Фотографий в игре нет и заводить их незачем, а список друзей из одних
 * строк читается как таблица. Цвет берётся из четырёх игровых — тех же, что
 * у фишек: другого набора красок в игре нет, и заводить его ради аватарок
 * значило бы спорить с доской.
 *
 * Цвет считается от ника, а не назначается: он должен быть одним и тем же
 * у одного человека на всех экранах и у всех, кто на него смотрит.
 */
const COLOURS: PlayerColor[] = ['red', 'green', 'yellow', 'blue']

function colourOf(name: string): PlayerColor {
  let sum = 0

  for (const symbol of name) {
    sum += symbol.codePointAt(0) ?? 0
  }

  return COLOURS[sum % COLOURS.length]
}

type Props = {
  name: string
  /** Показывать ли отметку «в сети». undefined — не показывать вовсе. */
  online?: boolean
  /** За этим местом сидит компьютер: вместо буквы — монитор. */
  bot?: boolean
  /** Загруженная картинка, если человек её поставил. */
  src?: string | null
  size?: 'm' | 'l'
}

export function Avatar({ name, online, bot = false, src = null, size = 'm' }: Props) {
  const letter = [...name][0]?.toUpperCase() ?? '?'

  return (
    <span className={`avatar avatar--${size} dot-${colourOf(name)}`}>
      {/*
       * Картинка, если её поставили; иначе буква — а у компьютера значок:
       * имя у него человеческое, и буква про него ничего не сказала бы.
       */}
      {src !== null ? (
        <img className="avatar__photo" src={src} alt="" />
      ) : bot ? (
        <ComputerIcon />
      ) : (
        <span aria-hidden="true">{letter}</span>
      )}
      {online !== undefined && (
        <span className={`avatar__mark${online ? ' avatar__mark--online' : ''}`} />
      )}
    </span>
  )
}
